export default __webpack_public_path__ + "static/1890_1900-c8163b23b8ca5a5921f46a145fa854a4.mp4";